import { use_slice_collections, use_slice_grid2d } from '@/hooks/store/use_slices';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { useMemo } from 'react';

export function HOOK_GRID2D_CELL__image_in_collection_current(cell: DTO__grid2d_cell) {
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);
  const { collection_current } = use_slice_collections(['collection_current']);
  /*
   *
   */
  let out = useMemo(() => get_image_in_collection_current(), [cell, grids2d_map, collection_current]);

  function get_image_in_collection_current() {
    if (cell.is_stub()) return false;
    if (cell.hash_sha256_content.is_empty_hash_sha256()) return false;

    if (!grids2d_map.has(collection_current._id)) return false; //not loaded yet

    let grid2d = grids2d_map.get_or_assert(collection_current._id);

    let cells_loaded = grid2d.cells__get_loaded();

    let out = false;

    for (let cell_loaded of cells_loaded) {
      if (cell_loaded.hash_sha256_content != cell.hash_sha256_content) continue;

      out = true;

      break;
    }

    return out;
  }

  return out;
}
